// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"738":"e247d991","966":"4d04909f"}[chunkId] + ".chunk.js";
};